import { useState, useEffect } from 'react'
import { Zap, Settings2 } from 'lucide-react'
import Modal, { FormField, FormInput, FormTextarea, FormActions, Button } from '../shared/Modal'

function NewRunModal({ isOpen, onClose, onStartStandard, onStartAdvanced, project }) {
  const [name, setName] = useState('')
  const [description, setDescription] = useState('')
  const [mode, setMode] = useState('standard') // 'standard' | 'advanced'
  const [errors, setErrors] = useState({})

  // Reset form when modal opens
  useEffect(() => {
    if (isOpen) {
      const defaultName = `Run — ${new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })}`
      setName(defaultName)
      setDescription('')
      setMode('standard')
      setErrors({})
    }
  }, [isOpen])

  const validate = () => {
    const errs = {}
    if (!name.trim()) errs.name = 'Run name is required'
    setErrors(errs)
    return Object.keys(errs).length === 0
  }

  const handleStart = () => {
    if (!validate()) return
    const runData = { name: name.trim(), description: description.trim(), mode }
    if (mode === 'advanced') {
      onStartAdvanced(runData)
    } else {
      onStartStandard(runData)
    }
    onClose()
  }

  const handleClose = () => {
    setErrors({})
    onClose()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title="Start New Run"
      size="medium"
    >
      <FormField label="Run Name" required error={errors.name}>
        <FormInput
          value={name}
          onChange={setName}
          placeholder="e.g., Sprint 12 — Full Pipeline"
          autoFocus
        />
      </FormField>

      <FormField label="Description">
        <FormTextarea
          value={description}
          onChange={setDescription}
          placeholder="Optional notes about this run..."
          rows={3}
        />
      </FormField>

      {/* Mode toggle */}
      <FormField label="Run Mode">
        <div className="run-mode-toggle">
          <button
            type="button"
            className={`run-mode-btn ${mode === 'standard' ? 'active' : ''}`}
            onClick={() => setMode('standard')}
          >
            <Zap size={16} />
            <div className="run-mode-text">
              <span className="run-mode-label">Standard</span>
              <span className="run-mode-desc">Guided step-by-step pipeline</span>
            </div>
          </button>

          <button
            type="button"
            className={`run-mode-btn ${mode === 'advanced' ? 'active' : ''}`}
            onClick={() => setMode('advanced')}
          >
            <Settings2 size={16} />
            <div className="run-mode-text">
              <span className="run-mode-label">Advanced</span>
              <span className="run-mode-desc">Full workflow builder</span>
            </div>
          </button>
        </div>
      </FormField>

      <p className="form-hint">* Required fields</p>

      <FormActions>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleStart}>
          {mode === 'advanced' ? 'Open Workflow Builder' : 'Start Run'}
        </Button>
      </FormActions>
    </Modal>
  )
}

export default NewRunModal
